// extracted by mini-css-extract-plugin
module.exports = {"container":"twitter-module--container--24Pul"};